import { render, staticRenderFns } from "./AttachFileField.vue?vue&type=template&id=6ef27943"
import script from "./AttachFileField.ts?vue&type=script&lang=ts&external"
export * from "./AttachFileField.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports